import { BaseInputField, Clause, FieldMapping } from "src/clients/flow-api/api";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";

export const extractWithPrefix = (field: BaseInputField): SearchableField => {
  return {
    id: field.id,
    value: `data.${field.value}`,
  };
};

export const extractClauses = (clauses: Clause[]): SearchableField[] =>
  clauses.flatMap((clause) => [
    { id: clause.id_left, value: clause.left },
    { id: clause.id_right, value: clause.right },
  ]);

export const extractInputMappings = (
  inputMappings: { [key: string]: FieldMapping } | undefined,
): SearchableField[] => {
  if (!inputMappings) {
    return [];
  }

  return Object.values(inputMappings).map((mapping) => ({
    id: mapping.id,
    value: mapping.source,
  }));
};
